/* eslint-disable react/display-name */
import React from 'react';

import cn from 'clsx';

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value'> {
  value?: boolean;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ value, className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type="checkbox"
        className={cn('form-checkbox h-5 w-5 text-gray-600', className)}
        checked={value}
        {...props}
      />
    );
  }
);

export default Checkbox;
